import { type App, computed, type ComputedRef, inject } from 'vue'
import { useBreakpoints } from '@vueuse/core'
import type { IsMobileAgentPlugin } from '@/plugins/is-mobile-agent.ts'

type Breakpoints = 640 | 478 | 1024

export const headerMobileBreakpoint: Breakpoints = 1024

export interface IsMobilePlugin {
    createIsMobile(breakpoint: Breakpoints): ComputedRef<boolean>
}

const key = 'app.plugin.is-mobile'
export function installIsMobile(
    app: App,
    isMobileAgentPlugin: IsMobileAgentPlugin
): IsMobilePlugin {
    const plugin: IsMobilePlugin = {
        createIsMobile(breakpoint: Breakpoints = 640): ComputedRef<boolean> {
            // eslint-disable-next-line vue-composable/composable-placement
            const isMobileBreakpoint = useBreakpoints({ breakpoint }).smaller(
                'breakpoint'
            )

            return computed(
                () =>
                    isMobileBreakpoint.value ||
                    isMobileAgentPlugin.isMobileAgent
            )
        },
    }

    app.provide(key, plugin)

    return plugin
}

export function useIsMobile(
    breakpoint: Breakpoints = 640
): ComputedRef<boolean> {
    return useIsMobilePlugin().createIsMobile(breakpoint)
}

export function useIsMobilePlugin(): IsMobilePlugin {
    return inject(key) as IsMobilePlugin
}
